import React from "react";
import { FaTimes } from "react-icons/fa";
import "../styles/InventoryHistory.css";

export default function InventoryHistory({ data, onClose }) {
  return (
    <div className="inventory-history-overlay">
      <div className="inventory-history-modal">
        {/* Header */}
        <div className="inventory-history-header">
          <h2>Inventory History Detail</h2>
          <button className="inventory-history-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* All Records */}
        <div className="inventory-history-content">
          {(!data || data.length === 0) ? (
            <div className="inventory-history-box">
              <p>No movement history yet.</p>
            </div>
          ) : data.map((row, idx) => (
            <div key={idx} className="inventory-history-box">
              <h3>{row.item} Update</h3>
              <p><strong>Date:</strong> {row.date}</p>
              <p><strong>Item Code:</strong> {row.code}</p>
              <p><strong>Quantity:</strong> {row.quantity}</p>
              <p><strong>Project:</strong> {row.project}</p>
              <p><strong>Remark/Note:</strong> {row.remark}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
